module.exports = __webpack_public_path__ + "static/sui-table-disabled-row-4eecb19cbdde16a060391e9628b792e3.png";